var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcQuesomaduroGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#87d7d6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.3,17.27a3.52,3.52,0,0,1,.56,0,3.69,3.69,0,0,1,.58,0L30.67,8.74A1.83,1.83,0,0,0,28.83,9L9.21,23.89c.12,0,40.09-6.62,40.09-6.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.16,37.61a5.49,5.49,0,0,1,3.54,1.3V20.7a1.84,1.84,0,0,0-1.4-1.79,2,2,0,0,0-.43-.05l-.31,0L10.5,25.3l-.66.11A1.85,1.85,0,0,0,8.3,27.23V38.56a4.2,4.2,0,0,1,2.66-1,4.79,4.79,0,0,1,0,9.55,4.22,4.22,0,0,1-2.66-.95v3.36a1.84,1.84,0,0,0,1.83,1.84l.31,0,32.33-5.31a6.45,6.45,0,0,1-.39-2.25,6,6,0,0,1,5.78-6.21ZM29.78,40.16a3.85,3.85,0,1,1,3.58-3.84A3.72,3.72,0,0,1,29.78,40.16Zm11.48-8.84a3.34,3.34,0,0,1-1.71-.46,3.9,3.9,0,0,1-1.87-3.38,3.72,3.72,0,0,1,3.58-3.85,3.53,3.53,0,0,1,3.12,2,4,4,0,0,1,.46,1.88,3.72,3.72,0,0,1-3.58,3.84Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcQuesomaduroGreen);
export default __webpack_public_path__ + "static/media/DC__Queso maduro_green.00a2c4b716b5e0a8f8effc840e7e5597.svg";
export { ForwardRef as ReactComponent };